import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SetupIntentResponse,
  StripeCustomerResponse,
  StripePaymentMethodDto
} from '../../models/billing';

@Injectable({ providedIn: 'root' })
export class PaymentApiService {
  private http = inject(HttpClient);

  createCustomer(facilityId: string): Observable<StripeCustomerResponse> {
    return this.http.post<StripeCustomerResponse>(
      `/api/facilities/${facilityId}/stripe/customer`,
      {}
    );
  }

  createSetupIntent(facilityId: string): Observable<SetupIntentResponse> {
    return this.http.post<SetupIntentResponse>(
      `/api/facilities/${facilityId}/stripe/setup-intent`,
      {}
    );
  }

  addPaymentMethod(
    facilityId: string,
    paymentMethodId: string
  ): Observable<void> {
    return this.http.post<void>(
      `/api/facilities/${facilityId}/stripe/payment-methods`,
      { paymentMethodId }
    );
  }

  deletePaymentMethod(
    facilityId: string,
    paymentMethodId: string
  ): Observable<void> {
    return this.http.delete<void>(
      `/api/facilities/${facilityId}/stripe/payment-methods/${paymentMethodId}`
    );
  }

  getPaymentMethods(facilityId: string): Observable<StripePaymentMethodDto[]> {
    return this.http.get<StripePaymentMethodDto[]>(
      `/api/facilities/${facilityId}/stripe/payment-methods`
    );
  }

  updateDefaultPaymentMethod(
    facilityId: string,
    paymentMethodId: string
  ): Observable<void> {
    return this.http.put<void>(
      `/api/facilities/${facilityId}/stripe/payment-methods/${paymentMethodId}`,
      { isDefault: true }
    );
  }
}
